import { defaultIconPath, directoryIconPath, mapSectors } from './BrandMapping'

const classNameJobTile: string = 'attrax-vacancy-tile'
    const classNameContainerLogo: string = `${classNameJobTile}__container-logo`
    const classNameContainerDetails: string = `${classNameJobTile}__container-details`
    const classNameLogo: string = `${classNameJobTile}__logo`
    const classNameDetails: Array<string> = [
        `${classNameJobTile}__description`,
        `${classNameJobTile}__salary`,
        `${classNameJobTile}__reference`,
        `${classNameJobTile}__expiry`,
        `${classNameJobTile}__location-freetext`,
        `${classNameJobTile}__option-department`,
        `${classNameJobTile}__option-job-type`,
        `${classNameJobTile}__option-location`,
        `${classNameJobTile}__option-brand`,
    ]

export const initialise = () => {
    const jobTiles: NodeListOf<HTMLDivElement> = document.querySelectorAll(`.${classNameJobTile}`)
    if (!jobTiles) return

    logoContainer(jobTiles)
    // moveDetails(jobTiles)
    updateLogo()
}

const logoContainer = (jobTiles: NodeListOf<HTMLDivElement>) => {
    jobTiles.forEach((jobTile: HTMLDivElement) => {
        let container: HTMLDivElement = document.createElement('div')
        container.classList.add(classNameContainerLogo)
        jobTile.prepend(container)

        let logo: HTMLImageElement = document.createElement('img')
        logo.alt = ''
        logo.loading = 'lazy'
        logo.height = 40
        logo.width = 300
        logo.src = defaultIconPath
        logo.className = classNameLogo
        container.appendChild(logo)
    })
}

const moveDetails = (jobTiles: NodeListOf<HTMLDivElement>) => {
    jobTiles.forEach((jobTile: HTMLDivElement) => {
        let container: HTMLDivElement = document.createElement('div')
        container.classList.add(classNameContainerDetails)
        jobTile.appendChild(container)

        const detailsSelector: string = classNameDetails.map(className => `.${className}`).join(', ')
        const details = jobTile.querySelectorAll<HTMLElement>(detailsSelector)
        details.forEach((detail: HTMLElement) => {
            container.appendChild(detail)
        })
    })
}

const updateLogo = () => {
    mapSectors.forEach(({ sector, fileType }) => {
        if (!sector) return

        const filePath: string = `${directoryIconPath}/${sector}.${fileType}`
        const jobTiles: NodeListOf<HTMLElement> = document.querySelectorAll(`.${classNameJobTile}.sector-${sector}`)

        jobTiles.forEach((jobTile: HTMLElement) => {
            const container = jobTile.querySelector<HTMLElement>(`.${classNameContainerLogo}`)
            if (!container) return
            const logo = container.querySelector<HTMLImageElement>('img')
            if (!logo) return
            logo.src = filePath
        })
    })
}
